/*
 * @Description:
 * @Author: zwcong
 * @Date: 2025-07-22 15:32:38
 * @LastEditors: zwcong
 * @LastEditTime: 2025-08-06 11:51:40
 */
import { oneApi } from 'config/api'

export default {
  data() {
    const { locale, localeConfig } = this.$store.state
    return {
      locale,
      showFooter: localeConfig.hasFooter,
      schoolList: this.$t('common.bm.schoolList') || [],
      follows: this.$t('common.bm.follows') || [],
      email: '',
      submiting: false,
      placeholder: 'Enter your email',
    }
  },
  computed: {
    logoUrl() {
      return this.$store.state.website.config.whiteLogo || this.$t('common.logo.normal')
    },
    isWebClient() {
      return process.env.clientType === 'web'
    },
  },
  methods: {
    validateEmail(email) {
      // 主流后缀列表
      const mainSuffixes = [
        'com', 'net', 'org', 'info', 'biz', 'xyz',
        'cn', 'com.cn', 'net.cn', 'org.cn',
        'co.uk', 'jp', 'kr', 'edu', 'gov',
      ];

      const suffixRegex = mainSuffixes.map((suffix) => suffix.replace(/\./g, '\\.')).join('|');
      const emailRegex = new RegExp(
        `^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.(${suffixRegex})$`,
      );

      return emailRegex.test(email);
    },
    handleSubmit() {
      // 验证邮箱
      if (!this.email) {
        if (this.isWebClient) {
          // this.$ElMessage.error('请输入邮箱');
          this.$ElMessage.error(this.$t('common.emailPlaceholder'))
        } else {
          // this.$Toast('请输入邮箱');
          this.$Toast(this.$t('common.emailPlaceholder'))
        }
        return
      }
      // 验证邮箱格式
      if (!this.validateEmail(this.email)) {
        if (this.isWebClient) {
          // this.$ElMessage.error('请输入正确的邮箱');
          this.$ElMessage.error(this.$t('common.emailError'))
        } else {
          // this.$Toast('请输入正确的邮箱');
          this.$Toast(this.$t('common.emailError'))
        }

        return
      }

      this.submiting = true
      this.$axios.post(oneApi.submitEmail, {
        email: this.email,
      }, { rewritePostBody: true }).then((res) => {
        if (Number(res.code) !== 0) {
          if (this.isWebClient) {
            this.$ElMessage({
              type: 'error',
              message: res.msg,
              offset: 80,
            });
          } else {
            this.$Notify({ type: 'warning', message: res.msg });
          }
          return
        }
        this.email = ''
        this.placeholder = 'Thank you！'
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
